import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import { CircularProgress, IconButton } from "@mui/material";
import { AcceptHostedForm } from "../Authorize/AcceptHostedForm";
const AuthEditButton = React.memo(({ card, formToken, selectedCard, authorizeUrl, setupIntentLoading = false, setSelectedCard, }) => {
    const handleClick = () => {
        setSelectedCard(card);
    };
    return (_jsx(AcceptHostedForm, Object.assign({ formToken: formToken, selectedCard: selectedCard, url: authorizeUrl, showPrimaryCheckbox: false, setSelectedCard: setSelectedCard }, { children: _jsx(IconButton, Object.assign({ color: "primary", type: "submit", onClick: handleClick }, { children: setupIntentLoading ? _jsx(CircularProgress, { size: 35 }) : _jsx(EditIcon, {}) })) })));
});
AuthEditButton.displayName = "AuthEditButton";
export default AuthEditButton;
